import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PollIcon from '@material-ui/icons/Poll';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import SchoolIcon from '@material-ui/icons/School';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, WithStyles, withStyles, useTheme, Theme, createStyles, createMuiTheme } from '@material-ui/core/styles';
import AdminExecutionList from "./AdminExecutionList";
import AdminClassRoomList from "./AdminClassRoomList";
import AdminLogin from "./AdminLogin";
import ExamServer from '../server/ExamServer'
import Grid from '@material-ui/core/Grid';


const drawerWidth = 240

const theme = createMuiTheme({
    // palette: {
    //     primary: {
    //         main: '#44423e'
    //     },
    //     secondary: {
    //         main: '#FDC400',
    //         contrastText: '#fff'
    //     }
    // }

});

const styles = ((theme: Theme) => createStyles({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}));

interface AdministrationProps extends WithStyles<typeof styles> {
    container?: Element;
    onClose: () => void
}
interface AdministrationState {
    mobileOpen?: boolean;
    loggedIn: boolean
    loading: boolean
    menuItem: "exams" | "classrooms"
}


class Administration extends React.Component<AdministrationProps, AdministrationState> {

    server: ExamServer;

    constructor(props: AdministrationProps) {
        super(props);
        this.state = {
            mobileOpen: false,
            loggedIn: false,
            loading: true,
            menuItem: "exams"
        };
        this.server = new ExamServer()
        this.server.login().then(successful => {

            this.setState({
                loading: false,
                loggedIn: successful
            })
        })
    }


    handleDrawerToggle = () => {
        this.setState({ mobileOpen: !this.state.mobileOpen })
    }

    handleClickExams = () => {
        this.setState({ menuItem: "exams" })
    }

    handleClickClassRooms = () => {
        this.setState({ menuItem: "classrooms" })
    }

    handleLogin = () => {
        this.setState({ loggedIn: true })
    }

    render() {

        const { classes } = this.props;
        const drawer = (
            <div>
                <div className={classes.toolbar} >
                    <Typography variant="h5" align={"center"} style={{ marginTop: theme.spacing(1) }}>
                        Examinator
                </Typography>
                    <Typography variant="subtitle2" align={"center"} color={"textSecondary"}>
                        v.1.0.0
                </Typography>
                </div>

                <Divider />

                <List>
                    <ListItem button selected={this.state.menuItem === "exams"} onClick={this.handleClickExams}>
                        <ListItemIcon>
                            <PollIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Examinations"} secondary={"All Test Results"} />
                    </ListItem>
                    <ListItem button selected={this.state.menuItem === "classrooms"} onClick={this.handleClickClassRooms}>
                        <ListItemIcon>
                            <SchoolIcon />
                        </ListItemIcon>
                        <ListItemText primary={"Class Rooms"} secondary={"Access Codes"} />
                    </ListItem>
                </List>

            </div>
        );

        return (

            <React.Fragment>


                <CssBaseline />

                {this.state.loading ? (
                    <Grid container
                        justify="center"
                        alignItems="center"
                        style={{
                            height: "calc(100vh - 100px)"
                        }}
                    >
                        <Grid item sm={12} md={8} lg={6} xl={6} style={{ textAlign: "center" }}>
                            <CircularProgress color="secondary" />
                        </Grid>
                    </Grid>
                ) : (
                        <React.Fragment>
                            {this.state.loggedIn ? (
                                <div className={classes.root}>
                                    <AppBar position="fixed" className={classes.appBar}>
                                        <Toolbar>
                                            <IconButton
                                                color="inherit"
                                                aria-label="open drawer"
                                                edge="start"
                                                onClick={this.handleDrawerToggle}
                                                className={classes.menuButton}
                                            >
                                                <MenuIcon />
                                            </IconButton>
                                            <Typography variant="h6" noWrap style={{ flexGrow: 1 }}>
                                                Administration
                        </Typography>
                                            <IconButton
                                                color="inherit"
                                                edge="end"
                                                onClick={this.props.onClose}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </Toolbar>
                                    </AppBar>

                                    <nav className={classes.drawer} aria-label="mailbox folders">
                                        <Hidden smUp implementation="css">
                                            <Drawer
                                                //container={container}
                                                variant="temporary"
                                                anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                                                open={this.state.mobileOpen}
                                                onClose={this.handleDrawerToggle}
                                                classes={{
                                                    paper: classes.drawerPaper,
                                                }}
                                                ModalProps={{
                                                    keepMounted: true, // Better open performance on mobile.
                                                }}
                                            >
                                                {drawer}
                                            </Drawer>
                                        </Hidden>
                                        <Hidden xsDown implementation="css">
                                            <Drawer
                                                classes={{
                                                    paper: classes.drawerPaper,
                                                }}
                                                variant="permanent"
                                                open
                                            >
                                                {drawer}
                                            </Drawer>
                                        </Hidden>
                                    </nav>
                                    <main className={classes.content}>
                                        <div className={classes.toolbar} />


                                        {this.state.menuItem === "exams" ? (
                                            <AdminExecutionList />
                                        ) : null}

                                        {this.state.menuItem === "classrooms" ? (
                                            <AdminClassRoomList />
                                        ) : null}

                                    </main>

                                </div>

                            ) : (
                                    <React.Fragment>
                                        <AppBar position="fixed">
                                            <Toolbar>
                                                <Typography variant="h6" noWrap style={{ flexGrow: 1 }}>
                                                    Administration
                                                </Typography>
                                                <IconButton
                                                    color="inherit"
                                                    edge="end"
                                                    onClick={this.props.onClose}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </Toolbar>
                                        </AppBar>
                                        <AdminLogin onLogin={this.handleLogin} />
                                    </React.Fragment>

                                )}
                        </React.Fragment>
                    )}

            </React.Fragment>

        )
    }
}
export default withStyles(styles)(Administration);